import { Component, Input, EventEmitter, Output } from '@angular/core';
import { ButtonSet } from '../../../models';

@Component({
  selector: 'button-set-list',
  template: `
    <div *ngIf="!buttonSets || !buttonSets.length" style="padding: 15px">
        You currently have no ButtonSet's.  Click Add to create one.
    </div>
    <nav *ngIf="buttonSets && buttonSets.length" class="sidenav-buttons">
        <h3>Button Sets</h3>
        <ul>
            <li *ngFor="let buttonSet of buttonSets">
                <a (click)="onSelect(buttonSet)"> {{ buttonSet.name }} </a>
            </li>
        </ul>
    </nav>
    `,
  styleUrls: ['./button-set-list.component.css']
})
export class ButtonSetListComponent {
  @Input() buttonSets: ButtonSet[];
  @Output() selected = new EventEmitter<ButtonSet>();

  constructor() {}

  onSelect(buttonSet: ButtonSet) {
    this.selected.emit(buttonSet);
  }
}
